import { ChangeDetectionStrategy, Component, computed, input, type InputSignal, type Signal } from '@angular/core';
import type { WishlistCreateStep, WishlistCreateStepState } from '@nexus/customer/wishlists/model';

interface WishlistCreateStepperItem {
  readonly id: WishlistCreateStep;
  readonly isActive: boolean;
  readonly isComplete: boolean;
}

@Component({
  selector: 'wishlist-create-stepper',
  imports: [],
  templateUrl: './wishlist-create-stepper.component.html',
  styleUrl: './wishlist-create-stepper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistCreateStepperComponent {
  public readonly steps: InputSignal<readonly WishlistCreateStepState[]> =
    input.required<readonly WishlistCreateStepState[]>();
  public readonly activeStep: InputSignal<WishlistCreateStep> = input.required<WishlistCreateStep>();

  protected readonly activeStepIndex: Signal<number> = computed((): number => {
    const activeStep: WishlistCreateStep = this.activeStep();
    const matchedStep: WishlistCreateStepState | undefined = this.steps().find(
      (step: WishlistCreateStepState): boolean => step.id === activeStep,
    );

    return matchedStep?.index ?? 1;
  });

  protected readonly stepCount: Signal<number> = computed((): number => this.steps().length);
  protected readonly stepperItems: Signal<readonly WishlistCreateStepperItem[]> = computed(
    (): readonly WishlistCreateStepperItem[] => {
      const activeStep: WishlistCreateStep = this.activeStep();
      const activeStepIndex: number = this.activeStepIndex();

      return this.steps().map(
        (step: WishlistCreateStepState): WishlistCreateStepperItem => ({
          id: step.id,
          isActive: step.id === activeStep,
          isComplete: step.index < activeStepIndex,
        }),
      );
    },
  );
}
